/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    src: PropTypes.string.isRequired,
    autoPlay: PropTypes.bool,
    loop: PropTypes.bool,
    muted: PropTypes.bool,
};

const defaultProps = {
    autoPlay: true,
    loop: true,
    muted: true,
};

function Video(props: any) {
    const className = clsx(props.className, 'video', {});

    const [timeout, setTimeoutState] = useState<number>();
    const containerRef = useRef<HTMLDivElement>(null);
    const videoRef = useRef<HTMLVideoElement>(null);

    const setCoverSizes = () => {
        if (containerRef.current && videoRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            videoRef.current.style.width = `${Math.round(containerRect.width)}px`;
            videoRef.current.style.height = `${Math.round(containerRect.height)}px`;
        }
    };

    const requestSetSizes = useCallback(() => {
        clearTimeout(timeout);
        setTimeoutState(window.setTimeout(setCoverSizes, 50));
    }, [timeout]);

    // cDM - on video loaded data set .
    useEffect(() => {
        const localVideoRef = videoRef; // for cleanup
        videoRef.current?.addEventListener('loadeddata', setCoverSizes);
        return () => {
            localVideoRef.current?.removeEventListener('loadeddata', setCoverSizes);
            clearTimeout(timeout);
        };
    }, [timeout]);

    // On Resize
    useEffect(() => {
        window.addEventListener('resize', requestSetSizes);
        return () => {
            window.removeEventListener('resize', requestSetSizes);
        };
    }, [requestSetSizes]);

    return (
        <div ref={containerRef} className={className} style={props.style}>
            <video
                ref={videoRef}
                src={props.src}
                autoPlay={props.autoPlay}
                playsInline={props.autoPlay}
                loop={props.loop}
                muted={props.muted}
            />
        </div>
    );
}

Video.propTypes = propTypes;
Video.defaultProps = defaultProps;

export default Video;
